<template lang="pug">
button.menu-item.transparent-button.no-scaling.px-0.py-0.w-100(
  @click='$emit(`click`)'
  :class='selected ? `selected`:``'
)
  .d-flex.align-items-center.px-3.py-3
    .avatar.rounded-circle
      img(src='@/assets/menu-item-icon.svg')
      //- i.fa.fa-money-check-alt
    .title.ml-3
      | {{ title }}
    i.fa.fa-arrow-right.ml-auto(style='font-size: 24px; color: #1F93CA;')
  hr.m-0
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: '...',
    },
    selected: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss">
.menu-item {
  &.transparent-button {
    &:hover {
      transform: scale(1);
    }
  }
  .avatar {
    width: 40px;
    height: 40px;
    background: #C0E5F2;

    color: #1F93CA;
    // font-size: 21px;

    display: flex;
    align-items: center;
    justify-content: center;

    img {
      width: 20px;
      height: 20px;
    }
  }
  .title {
    // font-size: 18px;
    font-size: 17px;
  }
}
</style>
